import { Menu, Plus } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Alert, Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ManagerBottomNavigationBar from '../../../components/ManagerBottomNavigationBar';
import ManagerShopItemCard from '../../../components/ManagerShopItemCard';
import SidebarMenu from '../../../components/SidebarMenu';
import SortableList from '../../../components/SortableList';
import useManagerShopStore from '../../../store/managerShop';

export default function ManagerShopPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const { items, isLoading, error, fetchShopItems, reorderItems } =
    useManagerShopStore();

  useEffect(() => {
    fetchShopItems();
  }, [fetchShopItems]);

  return (
    <div className="bg-white min-vh-100 d-flex flex-column">
      <Container fluid className="flex-grow-1 pb-5">
        {/* Sticky Header */}
        <div
          className="sticky-top bg-white"
          style={{
            zIndex: 1020,
            borderBottom: '1px solid rgba(0,0,0,0.1)',
          }}
        >
          <Row className="align-items-center p-4 pb-2">
            <Col xs="auto">
              <Menu
                className="text-dark"
                onClick={() => setShowSidebar(true)}
                style={{ cursor: 'pointer' }}
              />
            </Col>
            <Col className="text-center">
              <h2 className="text-dark h5 fw-bold mb-0">
                {t('manager.shop.title')}
              </h2>
            </Col>
            <Col xs="auto">
              <Button
                variant="primary"
                size="sm"
                className="rounded-circle p-2"
                onClick={() => navigate('/manager/create-shop-item')}
              >
                <Plus size={20} />
              </Button>
            </Col>
          </Row>
        </div>

        {/* Content */}
        <div className="px-0 pt-3">
          {isLoading && (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          )}

          {error && <Alert variant="danger">{error}</Alert>}

          {!isLoading && !error && items.length === 0 && (
            <p className="text-center text-muted py-4">
              {t('manager.shop.noItems')}
            </p>
          )}

          {!isLoading && !error && items.length > 0 && (
            <SortableList
              items={items}
              getId={item => item._id}
              onReorder={reorderItems}
              renderItem={(item, _index, dragHandleProps) => (
                <ManagerShopItemCard
                  item={item}
                  dragHandleProps={dragHandleProps}
                />
              )}
            />
          )}
        </div>
      </Container>

      <SidebarMenu show={showSidebar} onHide={() => setShowSidebar(false)} />
      <ManagerBottomNavigationBar />
    </div>
  );
}
